import React, { Component } from 'react';
import { injectIntl, defineMessages } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { Button } from 'primereact/button';
import { Panel } from 'primereact/panel';
import { Formik, Form, Field } from 'formik';
import PropTypes from 'prop-types';
import * as Yup from 'yup';
import { renderAsyncSelector } from '../../components/formik-components/FormAsyncSelector';
import { growlShape, intlShape, historyShape } from '../../components/prop-types';
import { getAccountsToTransferToInOrganisation } from '../../services/apps/AccountService';
import { growlErrors } from '../../utils/NotificationUtil';

import { withGrowl } from '../../components/GrowlNotifications';
import Debug from '../../components/Debug';
import FileDropzone from '../../components/file-dropzone/FileDropzone';

const getPreSelected = (transferToOptions) => {
  if (!transferToOptions.length > 0) {
    return null;
  }

  return transferToOptions[0];
};

const i18n = defineMessages({
  saveAgreementWith: { id: 'menu.save_agreement_with', defaultMessage: 'Save agreement with: ' },
  save: { id: 'attrs.save', defaultMessage: 'Save' },
  cancel: { id: 'actions.cancel', defaultMessage: 'Cancel' },
});

class NewCommercialAgreementForm extends Component {
  constructor() {
    super();

    this.state = {
      accounts: [],
      accountsLoading: false,
    };

    this.handleSearchAccounts = this.handleSearchAccounts.bind(this);
    this.cancelCreatingNewCommercialAgreement = this.cancelCreatingNewCommercialAgreement.bind(this);
  }

  componentWillMount() {
    const { accounts } = this.props;

    this.setState({
      accounts,
    });
  }

  cancelCreatingNewCommercialAgreement() {
    const { history, currentAccount } = this.props;
    const redirectUrl = `/accounts/${currentAccount}/commercial-agreements/`;
    history.push(redirectUrl);
  }

  async uploadCommercialAgreement(values, resetForm) {
    const { growl, uploadCommercialAgreement, history, currentAccount } = this.props;

    const { file } = values;

    try {
      await uploadCommercialAgreement({
        variables: {
          input: {
            promisorId: values.promisorId,
            promiseeId: values.promisee.id,
            fieldName: '1',
          },
          file,
        },
      });

      history.push(`/accounts/${currentAccount}/commercial-agreements`);
    } catch (err) {
      resetForm();
      growlErrors(growl, err);
    }
  }

  async handleSearchAccounts(query = null) {
    const { growl, currentAccount } = this.props;

    try {
      this.setState({ accountsLoading: true });
      const data = await getAccountsToTransferToInOrganisation({
        id: currentAccount,
        query,
      });
      this.setState({ accounts: data, accountsLoading: false });
    } catch (err) {
      this.setState({ accountsLoading: false });
      growlErrors(growl, err);
    }
  }

  render() {
    const {
      currentAccount,
      intl: { formatMessage },
    } = this.props;

    const { accounts, accountsLoading } = this.state;

    const transferToOptions = accounts
      .filter((a) => a.id !== currentAccount)
      .map((a) => ({
        name: `${a.displayName} - ${a.id}`,
        id: a.id,
      }));

    const preSelected = getPreSelected(transferToOptions);

    const validationSchema = Yup.object().shape({
      file: Yup.mixed().required(),
    });

    const initialValues = {
      promisorId: currentAccount,
      promisee: preSelected,
      file: null,
    };

    return (
      <div className="p-grid">
        <div className="p-col-12">
          <div className="brand-detailed-wrapper">
            <Panel>
              <div className="p-grid">
                <div className="p-sm-12 p-md-6">
                  <Formik
                    validationSchema={validationSchema}
                    initialValues={initialValues}
                    onSubmit={(values, formikBag) => {
                      const { resetForm } = formikBag;
                      this.uploadCommercialAgreement(values, resetForm);
                    }}
                  >
                    {({ isSubmitting, handleChange, setFieldValue, values }) => (
                      <Form>
                        <div className="p-grid p-fluid">
                          <input type="hidden" name="promisorId" value={currentAccount} />

                          <div className="p-col-12">
                            <FileDropzone />
                          </div>
                          <div className="p-col-12">
                            <label>{formatMessage(i18n.saveAgreementWith)}</label>
                            <Field
                              id="promisee"
                              name="promisee"
                              key="promisee"
                              required
                              textField="name"
                              valueField="id"
                              filter
                              component={renderAsyncSelector}
                              processing={accountsLoading}
                              data={transferToOptions}
                              onChange={handleChange}
                              setFieldValue={setFieldValue}
                              onSearch={this.handleSearchAccounts}
                            />
                          </div>
                        </div>
                        <br />
                        <div className="p-grid">
                          <div className="p-col-12">
                            <Button
                              type="button"
                              onClick={this.cancelCreatingNewCommercialAgreement}
                              className="p-button-secondary"
                              disabled={isSubmitting}
                              label={formatMessage(i18n.cancel)}
                            />
                            <Button
                              label={formatMessage(i18n.save)}
                              type="submit"
                              disabled={values.file === null || isSubmitting}
                            />
                            <Debug />
                          </div>
                        </div>
                      </Form>
                    )}
                  </Formik>
                </div>
              </div>
            </Panel>
          </div>
        </div>
      </div>
    );
  }
}

NewCommercialAgreementForm.propTypes = {
  currentAccount: PropTypes.string.isRequired,
  intl: intlShape.isRequired,
  growl: growlShape.isRequired,
  history: historyShape.isRequired,
  uploadCommercialAgreement: PropTypes.func.isRequired,
  accounts: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default withGrowl(withRouter(injectIntl(NewCommercialAgreementForm)));
